import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';
import '../App.css'

const Home = () => {
    return (
        <div className="App Home">
            <div className="Home-body">
                <Button className="playButton" size="lg" width="200px" height="75px" bg="white" color="black" _hover={{bg:"gray"}} as={Link} to='/Overview'>Play Game</Button>
            </div>
        </div>
    );
  };
  
export default Home;
  